"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Strikethrough: function() {
        return Strikethrough;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Strikethrough = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M8.325 7.94995C8.325 7.33195 8.652 6.70045 9.3375 6.18745C10.0245 5.67145 11.0205 5.32495 12.15 5.32495C13.824 5.32495 15.204 6.10945 15.696 6.89545C15.8541 7.14847 16.1063 7.3283 16.397 7.39539C16.6878 7.46248 16.9932 7.41134 17.2463 7.2532C17.4993 7.09507 17.6791 6.8429 17.7462 6.55217C17.8133 6.26144 17.7621 5.95597 17.604 5.70295C16.5945 4.09045 14.376 3.07495 12.15 3.07495C10.5795 3.07495 9.099 3.55345 7.9875 4.38745C6.873 5.22295 6.075 6.46795 6.075 7.94995C6.075 8.74795 6.3075 9.48295 6.7095 10.125H10.035C8.874 9.57895 8.325 8.69845 8.325 7.94995ZM3 13.125C3 12.8266 3.11853 12.5404 3.3295 12.3295C3.54048 12.1185 3.82663 12 4.125 12H19.875C20.1734 12 20.4595 12.1185 20.6705 12.3295C20.8815 12.5404 21 12.8266 21 13.125C21 13.4233 20.8815 13.7095 20.6705 13.9204C20.4595 14.1314 20.1734 14.25 19.875 14.25H17.4225C17.742 14.8365 17.925 15.492 17.925 16.2C17.925 17.682 17.127 18.9255 16.0125 19.7625C14.8995 20.5965 13.4205 21.075 11.85 21.075C9.6165 21.075 7.3695 20.0505 6.366 18.246C6.29005 18.1166 6.24074 17.9733 6.22096 17.8246C6.20119 17.6759 6.21136 17.5248 6.25086 17.3801C6.29037 17.2354 6.35841 17.1 6.451 16.982C6.54359 16.864 6.65884 16.7656 6.78999 16.6928C6.92114 16.62 7.06552 16.5741 7.21465 16.5579C7.36378 16.5417 7.51465 16.5555 7.65837 16.5985C7.8021 16.6415 7.93578 16.7127 8.05155 16.8081C8.16732 16.9035 8.26284 17.0211 8.3325 17.154C8.8305 18.048 10.1835 18.825 11.85 18.825C12.9795 18.825 13.974 18.4785 14.6625 17.9625C15.348 17.448 15.675 16.818 15.675 16.2C15.675 15.5475 15.2565 14.7945 14.3805 14.25H4.125C3.97726 14.25 3.83097 14.2209 3.69448 14.1643C3.55799 14.1078 3.43397 14.0249 3.3295 13.9204C3.22504 13.816 3.14217 13.692 3.08564 13.5555C3.0291 13.419 3 13.2727 3 13.125Z",
        fill: "currentColor"
    })
}), "Strikethrough");
const _default = Strikethrough;
